// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__SIVCl","content":"styles_content__2w8IA","row":"styles_row__3mtBw","footer":"styles_footer__3UVPY","phraseLength":"styles_phraseLength__3FxIQ"};